export default __webpack_public_path__ + "static/media/Beds and Wardrobes.99fe059e.jpg";